// material ui
import { Stack } from '@mui/material';

// api
import { ReadAlarmDto } from '@/api/generated/recalc/endpoints/v1/alarms';

// relative
import DataQualityThreshold from './alarmSubtype/DataQualityThreshold';

function renderAlarmSubtype(
  alarmSubType: ReadAlarmDto['AlarmSubtype'],
  metaData: ReadAlarmDto['MetaData'],
  alarm: ReadAlarmDto,
) {
  switch (alarmSubType) {
    case 'DataQualityThreshold':
      return <DataQualityThreshold alarm={alarm} />;
    default:
      return <pre>{JSON.stringify(metaData, null, 2)}</pre>;
  }
}

const QualityOfServiceDataStream = ({ alarm }: { alarm: ReadAlarmDto }) => {
  console.log('Rendering QualityOfServiceDataStream with alarm:', alarm);
  return (
    <Stack spacing={2}>
      {renderAlarmSubtype(alarm.AlarmSubtype, alarm.MetaData, alarm)}
    </Stack>
  );
};

export default QualityOfServiceDataStream;
